import React from 'react';
import PropTypes from 'prop-types';
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { getFullName } from '../../../../utility/finalCustomerUtils';
import { finalCustomerSolutionIdRules } from '../../../../config/constants/finalCustomerSolutionRuleConstants';

const FinalCustomerComponent = ({ field }) => {
  const { id } = useParams();
  const { translate: t } = useDictionaryTranslation();
  const solutionId = useSelector((state) => state.auth?.accountData?.solutionId);
  const finalCustomerSolutionRules = finalCustomerSolutionIdRules[solutionId] ?? finalCustomerSolutionIdRules.default;

  return (
    <React.Fragment key={field?.idInput}>
      <span>
        {' '}
        {getFullName(field?.valueObject, {
          useFullName: finalCustomerSolutionRules.showName1,
        })}{' '}
        - {field?.valueObject?.identificationType?.id}
        {field?.valueObject?.identification}{' '}
      </span>
      <Link to={`/services-detail/${id}/finalCustomer`}>{t('viewMore')}</Link>
    </React.Fragment>
  );
};

export default FinalCustomerComponent;

FinalCustomerComponent.propTypes = {
  field: PropTypes.object.isRequired,
};
